import axios from "axios";

function especialidad(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3119";
      axios
        .get(process.env.ROOT_API + "/exam_types/query/", {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in type_exam: ", err);
    }
  });
}

function especialidades_medicas(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3143";
      axios

        .post(process.env.ROOT_API + "/specialities/query", obj.body, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in especialidades_medicas: ", err);
    }
  });
}

function type_exam(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3119";
      axios
        .get(process.env.ROOT_API + "/exam_types/query/" + obj.esp, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in type_exam: ", err);
    }
  });
}

function exam_insert(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3115";
      axios
        .post(process.env.ROOT_API + "/exams/insert", obj.body, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in exam_insert: ", err);
    }
  });
}

function exam_query(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3116";
      axios
        .put(process.env.ROOT_API + "/exams/query", obj.body, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in exam_query: ", err);
    }
  });
}

function exam_delete(obj) {
  return new Promise((resolve, reject) => {
    try {
      let port = "";
      if (process.env.ROOT_API.includes("viewmedonline")) port = ":3118";
      axios
        .delete(process.env.ROOT_API + "/exams/delete/" + obj.body._id, {
          headers: {
            Authorization: obj.token
          }
        })
        .then(result => {
          resolve(result.data.documents);
        })
        .catch(error => {
          reject(error.response);
        });
    } catch (err) {
      console.log("err in exam_query: ", err);
    }
  });
}
export {
  especialidad,
  type_exam,
  exam_insert,
  exam_query,
  exam_delete,
  especialidades_medicas
};



// WEBPACK FOOTER //
// ./src/components/exams/examsServ.js